import React from 'react';
import classNames from 'classnames';
// import './ActionLinkGroupTitle.less'

interface IActionLinkGroupTitleProps extends React.HTMLProps<HTMLHeadingElement> {}

const getClassName = (className?: string) => classNames('dp-action-links__group-title', className);

/**
 * When action link call-outs have a title
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ActionLinkGroupTitle({ children }: IActionLinkGroupTitleProps) {
  return <h5 className={getClassName()}>{children}</h5>;
}
